{
  "version": 1,
  "asset_id": "76bab4b9-adcc-416b-a042-7b9532704643",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/76bab4b9-adcc-416b-a042-7b9532704643/destination-roofing-owner-sales-team-crystal-river-fl-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/76bab4b9-adcc-416b-a042-7b9532704643/destination-roofing-owner-sales-team-crystal-river-fl-768w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-768w.avif",
  "size": 24305,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
